<template>
    <f-dialog
        v-model       = "show"
        :width        = "950"
        :show-header  = "false"
        :hide-actions = "false"
        :inset        = "false"
        content-class = "dialog-border"
        :store-label  = "$t('dms.combine.label')"
        @store        = "onCombine"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div v-if="steps && documents" style="height: 600px">
                <div class="doc-target v-flex pa-4 pt-3">
                    <div class="pr-1 w-50" >
                        <v-select
                            :label         = "$t('dms.combine.targetstep')"
                            v-model        = "target.step"
                            :items         = "steps"
                            item-value     = "id"
                            item-text      = "name"
                            :return-object = true
                        >
                        </v-select>
                    </div>
                    <div class="pl-1 w-50">
                        <v-text-field
                            :label  = "$t('dms.combine.targetfile')"
                            v-model = "target.filename"
                        />
                    </div>

                </div>
                <div class="v-flex" style="height: calc(100% - 65px)">
                    <div class="ml-4 mr-1 mt-4 w-50" style="overflow-y: scroll">
                        <div
                            v-for = "(step,index) in steps"
                            :key  = "'step-' + index"
                            class = "lm-border mb-3 mr-1"
                        >
                            <div class="doc-step-header primary-background white--text pr-1">
                                {{ step.name }}
                            </div>
                            <div class="mt-0 mb-4 doc-step-scroll mr-1">
                                <div
                                    class="doc-step-document v-flex"
                                    v-for="(document, index) in getStepDocuments (step)"
                                    :key = "'doc-' + index"
                                >
                                    <div style="margin-top: 20px;">
                                        <v-checkbox
                                            class="pt-0 mt-0"
                                            v-model = "document.selected"
                                            :ripple = "false"
                                            hide-details
                                            @change = "onSelected"
                                        />
                                    </div>
                                    <div class="pt-1 w-100">
                                        <p-dms-entry-card
                                            class="lm-border mr-1"
                                            :document = document
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ml-4 mr-3 mt-4 mb-2 w-50 h-100">
                        <div class="doc-step-header primary-background white--text pr-1" style="width: calc(100% - 10px)">
                            Reihenfolge
                        </div>
                        <div class="pr-1 pt-0 mt-0 " style="border-top-left-radius: 0!important; border-top-right-radius: 0!important;">
                            <v-container fluid class="wrapper  doc-result-scroll pt-2 pr-1 mt-2" style="padding: 0!important;">
                                <drop-list
                                    :items="selected"
                                    class="list"
                                    @reorder="$event.apply(selected)"
                                >
                                    <template v-slot:item="{item}">
                                        <drag class="item lm-border mb-1 mr-1" :key="item.id">
                                            <p-dms-entry-card
                                                :document = "item"
                                            />
                                        </drag>
                                    </template>
                                </drop-list>
                            </v-container>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import { Drag, DropList } from "vue-easy-dnd";
import Inc     from "@/modules/inc/service/Inc";
import Core    from "@/modules/core/service/Core";
import FDialog from "@/modules/core/components/utils/FDialog.vue";
import PDmsEntryCard from "@/modules/dms/menu/components/private/PDmsEntryCard.vue";
import Dms from "@/modules/dms/common/service/Dms";

export default {
    name: "PDmsCombine",
    components: {
        PDmsEntryCard,
        FDialog,
        Drag,
        DropList
    },

    props: {
        stepDataId: {

        },

        value: {

        }
    },

    data: () => ({
        show     : false,
        documents: null,
        steps    : null,
        target: {
            step    : null,
            filename: null
        },
        selected: [],
    }),

    computed: {
        incident () {
            console.log("incident", this.$store.getters.incident)
            return this.$store.getters.incident;
        },
    },

    watch: {
        value () {
            this.show = this.value;
            if (this.show) {
                this.load();
            }
        }
    },

    mounted() {
        this.show = this.value;
        if (this.show) {
            this.load();
        }
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onCombine () {
            const documents = this.documents.filter (d => d.selected);
            if (!documents || documents.length === 0) {
                Core.message.error(this, this.$t('dms.combine.error.empty'))
                return;
            }

            if (documents.length < 2) {
                Core.message.error(this, this.$t('dms.combine.error.invalid'))
                return;
            }

            if (!this.target.filename || this.target.filename.trim ().length === 0) {
                Core.message.error(this, this.$t('dms.combine.error.filename'))
                return;
            }

            const documentIds = this.selected.map (d => d.id);
            const stepData    = this.incident.data.find (d => d.stepId === this.target.step.id);
            Inc.document.combine(this, documentIds, stepData.id, this.target.filename).then(data => {
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : stepData.id,
                    documents: data
                });

                Core.message.hint(this, this.$t("dms.combine.success", [this.target.filename]));
                this.$emit("input", false);
            });
        },

        onSelected () {
            this.selected = this.documents.filter (d => d.selected);
        },

        load () {
            this.selected = [];
            Inc.document.byIncident(this.incident.id, data => {
                const docs = data.filter (d => d.name.toUpperCase().endsWith("PDF"));
                this.steps = docs.map (d => {
                    return {
                        id  : d.step.id,
                        name: d.step.name
                    }
                }).filter((value, index, self) => self.map (v => v.id).indexOf(value.id) === index);


                const stepData       = this.incident.data.find (d => d.id === this.stepDataId);
                this.target.step     = this.steps.find(s => s.id === stepData.stepId);
                this.target.filename = this.$t('dms.combine.targetfilename');
                this.documents = docs;
            })
        },

        getStepDocuments (step) {
            return this.documents.filter(d => d.step.id === step.id);
        }
    }
}
</script>

<style scoped>

.doc-step-scroll {
    overflow-y: scroll;
    max-height: 450px;
}

.doc-result-scroll {
    overflow-y: scroll;
    height: 100%;
    max-height: 450px;
}

.doc-step-header {
    background-color: #f0f0f0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    width: calc(100% + 2px);
    margin-left: -1px;
    font-size: 15px;
}


.doc-target {
    height: 70px;
}

.doc-step-header, .doc-step-document {
    height: 30px;
    padding-top: 5px;
    padding-left: 12px;
}


.doc-step-document {
    font-size: 15px;
    height: 60px;
}

.centered-input >>> input {
    text-align: center
}

</style>